import { Box, Grid, Link, Typography } from '@material-ui/core';
import useStyles from './style';
import React, { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import MyEirSimReplacementTile from './MyEirSimReplacementTile';
import { getData } from '../account-details/myAccount.util';
import { getMsisdns } from './simReplacement.util';
import Loading from '../../../components/loading/Loading';
import { useHistory } from 'react-router-dom';
import { publish, subscribe } from 'pubsub-js';
import { getServiceId } from '../../getServiceID';
import { ArrowBackIcon } from '../../../sharedcomponents/inputs/svg-icons/CustomSvgIcons';
import { clearCacheQuery } from '../../../utils/cache';

const AccountSimreplacement = () => {
    const [contactDetails, setContactDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [retry, setRetry] = useState('');
    const classes = useStyles();
    const graphql = useApolloClient();
    const [msisdnVal, setMsisdnVal] = useState([]);
    const history = useHistory();

    const getDataUtil = async () => {
        await getData({ graphql, setContactDetails, setLoading, setRetry });
    };

    const getMisisdnsUtil = async () => {
        await getMsisdns({ setMsisdnVal });
    };

    const arrowAction = () => {
        if (sessionStorage.getItem('LoggedinUserBillType') === 'Prepay') {
            history.push('/prepay/dashboard');
        } else {
            history.push('/account/dashboard');
            publish('openhamburger');
        }
    };

    const reloadSimReplacementPage = async () => {
        console.log('RefreshSIMReplacementPage');
        clearCacheQuery(graphql, 'getMyServices');
        const serviceResponse = await getServiceId(graphql);
        if (serviceResponse[0]) {
            setLoading(true);
            getDataUtil();
            getMisisdnsUtil();
        }
    };
    useEffect(() => {
        if (sessionStorage.getItem('eSIM_Activation_InProgress')) {
            reloadSimReplacementPage();
        } else {
            getDataUtil();
            getMisisdnsUtil();
        }
    }, []);
    subscribe('RELOAD_SIMREPLACEMENT', reloadSimReplacementPage);
    return (
        <Box className={classes.AccountWrapper}>
            <Box className={classes.DetailsContainer}>
                <Box className={classes.headerBackIcon}>
                    <Link component='a' aria-label='Back to Dashboard' tabIndex='0'>
                        <ArrowBackIcon onClick={arrowAction} className={classes.arrow} />
                    </Link>
                </Box>
                {/* Enable eSIM feature */}
                {JSON.parse(sessionStorage.getItem('LoggedinUserFeatures')).filter(
                    feature => feature.feature_name === 'esim'
                ).length > 0 ? (
                    <Box className={classes.detailsHeaderbackText}>Manage SIM & eSIM</Box>
                ) : (
                    <Box className={classes.detailsHeaderbackText}>SIM replacement</Box>
                )}

                <Box className={classes.DividerLine}></Box>

                {loading ? (
                    retry == 'api-error' ? (
                        <div class={classes.ApiError}>
                            Something went wrong, please try again later.
                            {/* <span>Retry?</span> */}
                        </div>
                    ) : (
                        <Loading />
                    )
                ) : (
                    contactDetails !== null && (
                        <Grid container spacing={2} className={classes.SimreplacementWrapper}>
                            <Grid item>
                                <Typography variant='h5' className='details-topic-title'>
                                    Select your SIM:
                                </Typography>
                            </Grid>

                            {msisdnVal.map((item, index) => {
                                return (
                                    <Grid item className={`sim-img `}>
                                        <MyEirSimReplacementTile
                                            msisdn={item.msisdn}
                                            serviceId={item.id}
                                            ContactDetails={contactDetails}
                                            simCardType={item.simCardType}
                                            esimStatus={item.esimStatus}
                                        />
                                        <Box className='divider-line'></Box>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )
                )}
            </Box>
        </Box>
    );
};

export default AccountSimreplacement;
